import { isEqualUtil } from 'packages/src'

export default function areInstancesEqualReduxUtil (instanceA, instanceB) {
  return (
    isEqualUtil(instanceA?.data, instanceB?.data) &&
    isEqualUtil(instanceA?.changed, instanceB?.changed) &&
    isEqualUtil(instanceA?.status, instanceB?.status)
  )
}
